import update from 'immutability-helper';
import { OPEN_MY_INFO_LAYER, CLOSE_MY_INFO_LAYER, TOGGLE_MY_INFO_LAYER } from '../constants/ActionTypes';

const initialState = {
  openMyInfoLayer: false,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case TOGGLE_MY_INFO_LAYER:
      return update(state, {
        openMyInfoLayer: {
          $set: !state.openMyInfoLayer,
        },
      });
    case OPEN_MY_INFO_LAYER:
      return update(state, {
        openMyInfoLayer: {
          $set: true,
        },
      });
    case CLOSE_MY_INFO_LAYER:
      return update(state, {
        openMyInfoLayer: {
          $set: false,
        },
      });
  }
  return state;
};
